
















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class SwatcherBulma extends Vue {
  @Prop() selected!: string
  bgClasses = [
    'primary',
    'info',
    'success',
    'danger',
    'light',
    'warning',
    'dark',
    'dark-night',
  ]

  get selectedClass() {
    return this.selected
  }

  set selectedClass(value: string) {
    this.$emit('onSelected', value)
  }

  onSelectBg(selectedClass: string) {
    this.selectedClass = selectedClass
  }
}
